import { spawn } from 'redux-saga/effects';
import { authSaga } from './reducers/auth/saga';
import { userSaga } from './reducers/user/saga';
import { dashboardSaga } from './reducers/dashboard/saga';
import { monthlyFeeSaga } from './reducers/monthlyFee/saga';
import { vatReportSaga } from './reducers/vatreport/saga';
import { errorCorrectionsSaga } from './reducers/errorCorrections/saga';
import { swissPostSaga } from './reducers/swissPost/saga';
import { swedBankSaga } from './reducers/swedBank/saga';
import { mtdSaga } from './reducers/hmrc/saga';
import { gpsrSaga } from './reducers/gpsr/saga';
import { vatReimbursementsSaga } from './reducers/vatReimbursement/saga';
import { salesProcessingSaga } from './reducers/salesProcessing/saga';
import { referralsSaga } from './reducers/referrals/saga';
import { emManagementSaga } from './reducers/emManagement/saga';
import { countrySaga } from './reducers/country/saga';
import { currencySaga } from './reducers/currency/saga';
import { exchangeRatesSaga } from './reducers/exchangeRates/saga';
import { taxDutiesSaga } from './reducers/taxDuties/saga';
import { fiscalReportsSaga } from './reducers/fiscalReports/saga';
import { accessManagementSaga } from './reducers/accessManagement/saga';
import { changeHistorySaga } from './reducers/changeHistory/saga';
import { emProductFileUploadsSaga } from './reducers/emProductFileUploads/saga';
import { emVatSaga } from './reducers/emVat/saga';
import { emVatReportsSaga } from './reducers/emVatReports/saga';
import { attachmentsSaga } from './reducers/attachments/saga';
import { eudrSaga } from './reducers/eudr/saga';
import { jotformSaga } from './reducers/jotform/saga';
import { userRolesSaga } from './reducers/userRoles/saga';
import { generalAttachmentsSaga } from './reducers/generalAttachments/saga';
import { emAutomationScriptsSaga } from './reducers/emAutomationScripts/saga';
import { invoiceManagementSaga } from './reducers/invoiceManagement/saga';
import { orderManagementSaga } from './reducers/orderManagement/saga';
import { emailsSaga } from './reducers/emails/saga';
import { smsSaga } from './reducers/sms/saga';
import { userMgmtConnectedEmerchantsSaga } from './reducers/userMgmtConnectedEmerchants/saga';
import { emVatCorrectionsImportSaga } from './reducers/emVatCorrectionsImport/saga';
import { euDdpSaga } from './reducers/euDdp/saga';
import { shopifyStoresSaga } from './reducers/shopifyStores/saga';
import { emSalesReportsSaga } from './reducers/emSalesReports/saga';
import { easInfoSaga } from './reducers/easInfo/saga';
import { reportsSaga } from './reducers/reports/saga';
import { easFeeSaga } from './reducers/easFee/saga';
import { massPostSaleJobsSaga } from './reducers/massPostSaleJobs/saga';
import { supersetSaga } from './reducers/superset/saga';
import { prpSaga } from './reducers/prp/saga';
import { supportedPostalOperatorsSaga } from './reducers/supportedPostalOperators/saga';
import { ppwrSaga } from './reducers/ppwr/saga';
import { pgSettingsSaga } from './reducers/pgSettings/saga';

export function* rootSaga() {
	yield spawn(authSaga);
	yield spawn(userSaga);
	yield spawn(dashboardSaga);
	yield spawn(monthlyFeeSaga);
	yield spawn(vatReportSaga);
	yield spawn(errorCorrectionsSaga);
	yield spawn(swissPostSaga);
	yield spawn(swedBankSaga);
	yield spawn(mtdSaga);
	yield spawn(gpsrSaga);
	yield spawn(vatReimbursementsSaga);
	yield spawn(salesProcessingSaga);
	yield spawn(referralsSaga);
	yield spawn(emManagementSaga);
	yield spawn(countrySaga);
	yield spawn(currencySaga);
	yield spawn(exchangeRatesSaga);
	yield spawn(taxDutiesSaga);
	yield spawn(fiscalReportsSaga);
	yield spawn(accessManagementSaga);
	yield spawn(changeHistorySaga);
	yield spawn(emProductFileUploadsSaga);
	yield spawn(emVatSaga);
	yield spawn(emVatReportsSaga);
	yield spawn(attachmentsSaga);
	yield spawn(eudrSaga);
	yield spawn(jotformSaga);
	yield spawn(userRolesSaga);
	yield spawn(generalAttachmentsSaga);
	yield spawn(emAutomationScriptsSaga);
	yield spawn(invoiceManagementSaga);
	yield spawn(orderManagementSaga);
	yield spawn(emailsSaga);
	yield spawn(smsSaga);
	yield spawn(userMgmtConnectedEmerchantsSaga);
	yield spawn(emVatCorrectionsImportSaga);
	yield spawn(euDdpSaga);
	yield spawn(shopifyStoresSaga);
	yield spawn(emSalesReportsSaga);
	yield spawn(easInfoSaga);
	yield spawn(reportsSaga);
	yield spawn(easFeeSaga);
	yield spawn(massPostSaleJobsSaga);
	yield spawn(supersetSaga);
	yield spawn(prpSaga);
	yield spawn(supportedPostalOperatorsSaga);
	yield spawn(ppwrSaga);
	yield spawn(pgSettingsSaga);
}
